import { ActionTree } from "vuex";
import { RootState } from "../../store";
import { PlanTrailState } from "../PlanTrailModule";

// Import all action modules
import { undoRedoActions } from "./undo-redo";
import { saveShareActions } from "./save-share";
import { initializationActions } from "./initialization";
import { markerActions } from "./markers";
import { polylineActions } from "./polylines";
import { mapInteractionsActions } from "./map-interactions";
import { routeOperationsActions } from "./route-operations";
import { fileOperationsActions } from "./file-operations";
import { multiRouteActions } from "./multi-route";
import { dragPreviewActions } from "./drag-preview";
import { highlightActions } from "./highlights";
import { poiInteractionsActions } from "./poi-interactions";
import { routeValidationActions } from "./route-validation";
import { selectionActions } from "./selection";
import { controlPointSpacingActions } from "./controlPointSpacing";
import { cueActions } from "./cues";
import { mapMatchActions } from "./map-match";

// Import existing refactored actions
import refactoredActions from "../actions-refactored";

// Combine all actions into a single ActionTree
const actions: ActionTree<PlanTrailState, RootState> = {
  // Initialization actions
  ...initializationActions,

  // Undo/Redo actions
  ...undoRedoActions,

  // Marker management actions
  ...markerActions,

  // Polyline/LineString actions
  ...polylineActions,

  // Map interaction actions
  ...mapInteractionsActions,

  // Hand-added turn cues
  ...cueActions,

  // Admin map-matching of imported routes
  ...mapMatchActions,

  // Route operation actions
  ...routeOperationsActions,

  // File operation actions
  ...fileOperationsActions,

  // Multi-route actions
  ...multiRouteActions,

  // Drag preview actions
  ...dragPreviewActions,
  
  // Highlight actions
  ...highlightActions,
  
  // POI interaction actions
  ...poiInteractionsActions,
  
  // Route validation actions
  ...routeValidationActions,

  // Area selection actions
  ...selectionActions,

  // Evenly-spaced control point actions
  ...controlPointSpacingActions,

  // Save and share actions
  ...saveShareActions,

  // Include existing refactored actions
  ...refactoredActions
};

export default actions;
